import { ReactNode } from 'react';
import { CardWithTitle } from '../CardWithTitle';

export interface DetailViewCardProps {
  title: string;
  children: ReactNode;
  childrenWrapperClass?: string;
  cardActions?: ReactNode;
  enableCollapse?: boolean;
  className?: string;
  collapsed?: boolean;
  dataCy?: string;
  titlePadding?: string;
  onCollapseClick?: (collapse: boolean) => void;
}

export function DetailViewCard({
  title,
  children,
  childrenWrapperClass,
  cardActions,
  enableCollapse,
  className,
  collapsed = false,
  titlePadding = 'p-3',
  dataCy = '',
  onCollapseClick
}: DetailViewCardProps) {
  return (
    <CardWithTitle
      cardActions={cardActions}
      title={title}
      enableCollapse={enableCollapse}
      onCollapseClick={onCollapseClick}
      titlePadding={titlePadding}
      className={className}
      childrenWrapperClass={childrenWrapperClass}
      collapsed={collapsed}
      dataCy={dataCy}>
      {children}
    </CardWithTitle>
  );
}
